const currencyList = {
  el: {
    currencyListContainers: null as NodeListOf<HTMLElement> | null,
  },
  init() {
    this.el.currencyListContainers = document.querySelectorAll('.currency-list__root')
    if (!this.el.currencyListContainers.length) {
      return
    }

    let isLocalUpdate = false

    const updateCurrencyLists = (updatedCurrency) => {
      this.el.currencyListContainers.forEach((currencyListContainer) => {
        const buttonText = currencyListContainer.querySelector('.button__text')
        const listWrapper = currencyListContainer.querySelector('.currency-list__wrapper')
        const currencyButtons = listWrapper.querySelectorAll('.currency-button')

        function setActiveButton(selectedButton) {
          currencyButtons.forEach((btn) => {
            btn.classList.remove('currency-button--active')
            btn.setAttribute('aria-selected', 'false')
          })
          selectedButton.classList.add('currency-button--active')
          selectedButton.setAttribute('aria-selected', 'true')
          buttonText.textContent = selectedButton.getAttribute('title')
        }

        currencyButtons.forEach((btn) => {
          if (btn.getAttribute('title') === updatedCurrency) {
            setActiveButton(btn)
          }
        })
      })
    }

    this.el.currencyListContainers.forEach((currencyListContainer) => {
      const button = currencyListContainer.querySelector('.footer__dropdown-button')
      const buttonText = button.querySelector('.button__text')
      const listWrapper = currencyListContainer.querySelector('.currency-list__wrapper')
      const storedCurrency = localStorage.getItem('currency') || 'ISK'
      const currencyButtons = listWrapper.querySelectorAll('.currency-button')

      function setActiveButton(selectedButton) {
        currencyButtons.forEach((btn) => {
          btn.classList.remove('currency-button--active')
          btn.setAttribute('aria-selected', 'false')
        })
        selectedButton.classList.add('currency-button--active')
        selectedButton.setAttribute('aria-selected', 'true')
        buttonText.textContent = selectedButton.getAttribute('title')
      }

      const handleDropdownClick = (e) => {
        e.stopImmediatePropagation()
        listWrapper.classList.toggle('open')
        const ariaExpanded = listWrapper.classList.contains('open') === true ? 'true' : 'false'
        button.setAttribute('aria-expanded', ariaExpanded)
        e.stopPropagation()
      }

      function handleButtonClick(e) {
        e.stopImmediatePropagation()
        const button = e.target.closest('.currency-button')
        if (!button) {
          return
        }

        const selectedCurrency = button.getAttribute('title')
        localStorage.setItem('currency', selectedCurrency)
        localStorage.setItem('rate', button.getAttribute('data-rate'))
        setActiveButton(button)

        isLocalUpdate = true
        updateCurrencyLists(selectedCurrency)
        import('components/format-all-prices').then((module) => module.default.init())
        import('components/calculate-price').then((module) => {
          module.default.updatePrices(e)
        })
        listWrapper.classList.remove('open')
        e.stopPropagation()
      }

      currencyButtons.forEach((btn) => {
        btn.removeEventListener('click', handleButtonClick)
        if (btn.getAttribute('title') === storedCurrency) {
          btn.classList.add('currency-button--active')
          btn.setAttribute('aria-selected', 'true')
          buttonText.textContent = btn.getAttribute('title')
        }
        btn.addEventListener('click', handleButtonClick)
      })

      button.removeEventListener('click', handleDropdownClick)
      button.addEventListener('click', handleDropdownClick)
    })

    window.addEventListener('storage', (e) => this.storageEvent(e, isLocalUpdate, updateCurrencyLists))
  },

  storageEvent(e, isLocalUpdate, updateCurrencyLists) {
    e.stopImmediatePropagation()
    if (e.key === 'currency' && !isLocalUpdate) {
      const updatedCurrency = e.newValue
      if (updatedCurrency) {
        updateCurrencyLists(updatedCurrency)
      }
    }
    isLocalUpdate = false
    e.stopPropagation()
  },
}

export default currencyList
